'use client'

import { AppLoading } from '@/components/ui/app-loading'

export default function RootLoading() {
  return <AppLoading />
}
